/**
 * 配时档案组件
 */
import React, { useState, useEffect } from 'react';
import { Drawer, message, 
    Timeline, Row, Col,Tag} from 'antd';
import $ from 'jquery';
import { ClockCircleOutlined,EditFilled } from '@ant-design/icons';
import { AddRequestHeaders, UjoinParams, winWidth } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const TimingArchive = (props) => {
    const [record, setRecord] = useState(props.record);
    const [open, setOpen] = useState(false);
    const [items, setItems] = useState([]);

    useEffect(()=>{
        setOpen(props.open);
    }, [props]);

    //  取消
    const handleCancel = () => {setOpen(false);}

    useEffect(()=>{
        /**
         * 获取配时日志数据
         * @param {*} ulid 配时ulid
         */
        const getData = (ulid) =>{
            const params = {
                'timing_ulid': ulid,
                'page_size': 65535,
            };
            $.ajax({
                url: `${CNF.api}log/timings${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',success:function(data){
                    if(data.res === 0){
                        if(data.dat.length > 0){
                            let newItems = [];
                            for(let i=data.dat.length-1; i>0; i--){
                                let d = data.dat[i];
                                //  上一个节点
                                let ud = i > 0 ? data.dat[i-1] : null;
                                let children = <>
                                    <p>{d.create_time}</p>
                                    <Row>
                                        <Col span={4}><strong>操作者：</strong></Col><Col span={7}>{d.operation}</Col>
                                        <Col span={4} offset={2}><strong>动作：</strong></Col><Col span={7}>{
                                            [0].map(()=>{
                                                if(d.action === 'CREATE'){
                                                    return <Tag color='cyan'>创建</Tag>
                                                }else if(d.action === 'IMPORT'){
                                                    return <Tag color='green'>导入</Tag>
                                                }else{
                                                    return <Tag color='orange'>修改</Tag>
                                                }
                                            })
                                        }</Col>
                                    </Row>
                                    <Row style={{ marginTop: 5 }}>
                                        <Col span={4}><strong>时段：</strong></Col><Col span={7}>{d?d.time_period:''}&nbsp;{ud&&d&&ud.time_period!==d.time_period?<EditFilled style={{ color: 'red' }}/>:''}</Col>
                                        <Col span={4} offset={2}><strong>方向：</strong></Col><Col span={7}>{d?d.direction:''}&nbsp;{ud&&d&&ud.direction!==d.direction?<EditFilled style={{ color: 'red' }}/>:''}</Col>
                                    </Row>
                                    <Row style={{ marginTop: 5 }}><Col span={4}><strong>星期：</strong></Col><Col span={20}>{
                                        d.week && d.week.length>0 && d.week.map((item) => {
                                            switch(item){
                                                case '1':
                                                    return <Tag color='blue'>星期一</Tag>
                                                case '2':
                                                    return <Tag color='blue'>星期二</Tag>
                                                case '3':
                                                    return <Tag color='blue'>星期三</Tag>
                                                case '4':
                                                    return <Tag color='blue'>星期四</Tag>
                                                case '5':
                                                    return <Tag color='blue'>星期五</Tag>
                                                case '6':
                                                    return <Tag color='cyan'>星期六</Tag>
                                                case '0':
                                                    return <Tag color='cyan'>星期日</Tag>
                                                default:
                                                    return ''
                                            }
                                        })
                                    }&nbsp;{ud&&d&&ud.week.toString()!==d.week.toString()?<EditFilled style={{ color: 'red' }}/>:''}</Col></Row>
                                    <Row style={{ marginTop: 5 }}><Col span={4}><strong>时长：</strong></Col><Col span={20}>{
                                        [0].map(()=>{
                                            if(parseInt(d.duration) === 0){
                                                return <Tag color='gold'>黄闪</Tag>
                                            }else if(parseInt(d.duration) === -1){
                                                return <Tag color='green'>常绿</Tag>
                                            }else if(parseInt(d.duration) === -2){
                                                return <Tag color='red'>关闭</Tag>
                                            }else{
                                                return <span>{d.duration}&nbsp;秒</span>
                                            }
                                        })
                                    }&nbsp;{ud&&d&&ud.duration!==d.duration?<EditFilled style={{ color: 'red' }}/>:''}</Col></Row>
                                </>
                                
                                let color = '#1677ff';  //  默认蓝色
                                if(d.action === 'CREATE'){
                                    color = '#FF904D';  //  创建橙色
                                }else if(d.action === 'IMPORT'){
                                    color = 'green';    //  导入绿色
                                }
                                let item = {
                                    children: children,
                                    color: color,
                                }
                                //  创建或者导入添加时间icon
                                if(['CREATE','IMPORT'].includes(d.action)){
                                    item.dot = (
                                        <ClockCircleOutlined style={{fontSize: '16px',}}/>
                                    )
                                }
                                newItems.push(item);
                            }
                            setItems(newItems);
                        }else{
                            setItems([]);
                        }
                    }else{
                        message.error(data.msg, 1.5);
                    }
                }
            })
        }
        //  初始化和切换配时调用
        if(items.length <1 || record !== props.record){
            setRecord(props.record);
            getData(props.record.key)
        }
    }, [props.record,record,items]);

    return <Drawer 
        closeIcon={false}
        width={winWidth>1440?winWidth/3:winWidth/2}
        title='配时档案管理'
        onClose={handleCancel} 
        open={open}>
            <>
                <Row><Col span={4}><strong>路口名称：</strong></Col><Col span={20}>{record?record.intersection_name:''}</Col></Row>
                <Row style={{ marginTop: 10 }}><Col span={4}><strong>路口编码：</strong></Col><Col span={20}>{record?record.intersection_number:''}</Col></Row>
                <Row style={{ marginTop: 10 }}>
                    <Col span={4}><strong>当前时段：</strong></Col><Col span={7}>{record?record.time_period:''}</Col>
                    <Col span={4} offset={2}><strong>当前方向：</strong></Col><Col span={7}>{record?record.direction:''}</Col>
                </Row>
                <Row style={{ marginTop: 10 }}><Col span={4}><strong>当前星期：</strong></Col><Col span={20}>{
                    record.week && record.week.length>0 && record.week.map((item) => {
                        switch(item){
                            case '1':
                                return <Tag color='blue'>星期一</Tag>
                            case '2':
                                return <Tag color='blue'>星期二</Tag>
                            case '3':
                                return <Tag color='blue'>星期三</Tag>
                            case '4':
                                return <Tag color='blue'>星期四</Tag>
                            case '5':
                                return <Tag color='blue'>星期五</Tag>
                            case '6':
                                return <Tag color='cyan'>星期六</Tag>
                            case '0':
                                return <Tag color='cyan'>星期日</Tag>
                            default:
                                return ''
                        }
                    })
                }</Col></Row>
                <Row style={{ marginTop: 10 }}><Col span={4}><strong>当前时长：</strong></Col><Col span={20}>{
                    [0].map(()=>{
                        if(parseInt(record.duration) === 0){
                            return <Tag color='gold'>黄闪</Tag>
                        }else if(parseInt(record.duration) === -1){
                            return <Tag color='green'>常绿</Tag>
                        }else if(parseInt(record.duration) === -2){
                            return <Tag color='red'>关闭</Tag>
                        }else{
                            return <span>{record.duration}&nbsp;秒</span>
                        }
                    })
                }</Col></Row>
                <Row style={{ marginTop: 10 }}><Col span={4}><strong>配时ULID：</strong></Col><Col span={20}>{record?record.key:''}</Col></Row>
                <p>以下是详细配时记录：</p>
                <Row style={{ padding: 5 }}>
                    <Timeline
                        mode='left'
                        items={items}
                        style={{ width: '100%' }}
                    />
                </Row>
            </>
    </Drawer>
}

export default TimingArchive;